<ng-template [ngIf]="user" [ngIfElse]="empty">
  <mat-list dense twoLine interactive="false">
    <mat-list-item>
      <sn-icon mat-list-icon>account_circle</sn-icon>
      <div mat-line style="font-size: 17px">{{ user.firstName }}</div>
      <div mat-line style="font-size: 14px; color: gray">{{ 'common.firstName' | t }}</div>
    </mat-list-item>

    <mat-list-item>
      <sn-icon mat-list-icon>account_circle</sn-icon>
      <div mat-line style="font-size: 17px">{{ user.lastName }}</div>
      <div mat-line style="font-size: 14px; color: gray">{{ 'common.lastName' | t }}</div>
    </mat-list-item>

    <mat-list-item>
      <sn-icon mat-list-icon>contacts</sn-icon>
      <div mat-line style="font-size: 17px">{{ user.badge }}</div>
      <br />
      <div mat-line style="font-size: 14px; color: gray">{{ 'common.badge' | t }}</div>
    </mat-list-item>

    <mat-list-item>
      <sn-icon mat-list-icon>mail</sn-icon>
      <div mat-line style="font-size: 17px">{{ user.email }}</div>
      <div mat-line style="font-size: 14px; color: gray">{{ 'common.email' | t }}</div>
    </mat-list-item>

    <mat-list-item>
      <sn-icon mat-list-icon>phone</sn-icon>
      <div mat-line style="font-size: 17px">{{ user.mobilePhone | fsPhoneNumber }}</div>
      <div mat-line style="font-size: 14px; color: gray">{{ 'common.mobilePhone' | t }}</div>
    </mat-list-item>

    <mat-list-item>
      <sn-icon mat-list-icon>access_time</sn-icon>
      <div mat-line style="font-size: 17px">
        <sn-user-last-active [user]="user"></sn-user-last-active>
      </div>
      <div mat-line style="font-size: 14px; color: gray">{{ 'common.lastActive' | t }}</div>
    </mat-list-item>
  </mat-list>
</ng-template>

<ng-template #empty></ng-template>
